export function manuallyFocusElement (className: string) {
  (document.querySelector('.' + className) as HTMLElement).focus()
}
